module.exports = __webpack_public_path__ + "static/avatar_valeria_lanskaya@2x-d4430fa49e4f83ceef45741c72bb850e.jpg";